#vc-spotify-player {
    padding: 12px;
    background: var(--bg-overlay-floating, var(--background-base-low, var(--background-base-lower-alt)));
    margin: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 1px solid var(--border-subtle);

    /* so custom themes can easily change it */
    --vc-spotify-green: var(--spotify, #1db954);
    --vc-spotify-green-90: color-mix(in hsl, var(--vc-spotify-green), transparent 90%);
    --vc-spotify-green-80: color-mix(in hsl, var(--vc-spotify-green), transparent 80%);
}

.theme-light #vc-spotify-player {
    background: var(--bg-overlay-3, var(--background-base-lower-alt));
}

.theme-dark #vc-spotify-player {
    background: var(--bg-overlay-1, var(--background-base-lower-alt));
}

.vc-spotify-button {
    margin: 0 2px;
    border-radius: var(--radius-sm);
    background: none;
    color: var(--interactive-normal);
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.vc-spotify-button:hover {
    color: var(--interactive-hover);
    background-color: var(--background-modifier-selected);
}

.vc-spotify-button-icon {
    height: 24px;
    width: 24px;
}

.vc-spotify-shuffle .vc-spotify-button-icon,
.vc-spotify-repeat .vc-spotify-button-icon {
    width: 22px;
    height: 22px;
}

/* .vc-spotify-button:hover {
    filter: brightness(1.3);
} */

.vc-spotify-repeat-context,
.vc-spotify-repeat-track,
.vc-spotify-shuffle-on {
    background-color: var(--vc-spotify-green-90);
}

.vc-spotify-repeat-context:hover,
.vc-spotify-repeat-track:hover,
.vc-spotify-shuffle-on:hover {
    background-color: var(--vc-spotify-green-80);
}

.vc-spotify-tooltip-text {
    overflow: hidden;
    white-space: nowrap;
    padding-right: 0.2em;
    max-width: 100%;
    margin: unset;
}

.vc-spotify-repeat-1 {
    font-size: 70%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.vc-spotify-button-row {
    justify-content: center;
    margin-top: 14px;
}

.vc-spotify-secondary-song-info {
    font-size: 12px;
}

.vc-spotify-song-info-prefix {
    display: none;
}

#vc-spotify-info-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 3em;
    gap: 0.5em;
}

#vc-spotify-album-image {
    height: 90%;
    object-fit: contain;
    border-radius: 3px;
    transition: filter 0.2s;
}

#vc-spotify-album-image:hover {
    filter: brightness(1.2);
    cursor: pointer;
}

#vc-spotify-album-expanded-wrapper #vc-spotify-album-image {
    width: 100%;
    object-fit: contain;
}

#vc-spotify-titles {
    display: flex;
    flex-direction: column;
    padding: 0.2rem;
    align-items: flex-start;
    place-content: flex-start center;
    overflow: hidden;
}

#vc-spotify-song-title {
    color: var(--header-primary);
    font-size: 14px;
    font-weight: 600;
}

.vc-spotify-ellipoverflow {
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
    text-overflow: ellipsis;
}

.vc-spotify-artist,
.vc-spotify-album {
    font-size: 12px;
    text-decoration: none;
    color: var(--header-primary);
}

.vc-spotify-comma {
    color: var(--header-secondary);
}

.vc-spotify-artist[role="link"]:hover,
#vc-spotify-album-title[role="link"]:hover,
#vc-spotify-song-title[role="link"]:hover {
    text-decoration: underline;
    cursor: pointer;
}

#vc-spotify-progress-bar {
    position: relative;
    color: var(--text-default);
    width: 100%;
    margin: 0.5em 0;
    margin-bottom: 5px;
}

#vc-spotify-progress-bar > [class^="slider"] {
    flex-grow: 1;
    width: 100%;
    padding: 0 !important;
}

#vc-spotify-progress-bar > [class^="slider"] [class^="bar"] {
    height: 3px !important;
    top: calc(12px - 4px / 2 + var(--bar-offset));
}

#vc-spotify-progress-bar > [class^="slider"] [class^="barFill"] {
    background-color: var(--interactive-active);
}

#vc-spotify-progress-bar > [class^="slider"]:hover [class^="barFill"] {
    background-color: var(--vc-spotify-green);
}

#vc-spotify-progress-bar > [class^="slider"] [class^="grabber"] {
    /* these importants are necessary, it applies a width and height through inline styles */
    height: 16px !important;
    width: 16px !important;
    margin-top: calc(17px/-2 + var(--bar-offset)/2);
    margin-left: -0.5px;
    background-color: var(--interactive-active);
    border-color: var(--interactive-normal);
    color: var(--interactive-normal);
    opacity: 0;
    transition: opacity 0.1s;
}

#vc-spotify-progress-bar:hover > [class^="slider"] [class^="grabber"] {
    opacity: 1;
}

#vc-spotify-progress-text {
    margin: 0;
}

.vc-spotify-progress-time {
    font-size: 12px;
    top: 10px;
    position: absolute;
    margin-top: 8px;
    font-family: var(--font-code);
}

.vc-spotify-time-left {
    left: 0;
}

.vc-spotify-time-right {
    right: 0;
}

.vc-spotify-fallback {
    padding: 0.5em;
    color: var(--text-default);
}